var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subnav" },
    [
      _c(
        "v-expansion-panel",
        {
          model: {
            value: _vm.pannelSidebar,
            callback: function($$v) {
              _vm.pannelSidebar = $$v
            },
            expression: "pannelSidebar"
          }
        },
        [
          _c(
            "v-expansion-panel-content",
            { class: _vm.activeAnchor(), attrs: { "hide-actions": "" } },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "sidebar-profile__header",
                      attrs: { to: _vm.redirectTo() }
                    },
                    [
                      _c("span", { class: _vm.activeAnchorTxt() }, [
                        _vm._v(_vm._s(_vm.$t(_vm.lblSetting.account)))
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t(_vm.lblSetting.notificationDetails)))
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  !_vm.coLoader
                    ? _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.notificationDetails, function(notif, index) {
                          return _c(
                            "v-list-tile",
                            {
                              key: index,
                              class: _vm.activeAnchor(
                                _vm.notificationHash(notif)
                              ),
                              attrs: { href: _vm.notificationHash(notif) },
                              on: {
                                click: function(e) {
                                  return _vm.onNavBarOptionClick(
                                    e,
                                    _vm.notificationHash(notif)
                                  )
                                }
                              }
                            },
                            [
                              _c("v-list-tile-content", [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        _vm.activeAnchorTxt(
                                          _vm.notificationHash(notif)
                                        ) + " ml-3"
                                    },
                                    [_vm._v(_vm._s(notif))]
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c("notification-subsection-loader")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta["view_team_account"]
            ? _c(
                "v-expansion-panel-content",
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t(_vm.lblSetting.profileTeamManagementBtn))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          !_vm.isServiceBookOwner
                            ? _c(
                                "v-list-tile",
                                { class: _vm.activeAnchor("team-management") },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "team-management"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "team-management"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileTeamManagement
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { class: _vm.activeAnchor("other-users") },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "sidebar-profile__item",
                                          attrs: {
                                            to: _vm.redirectTo("other-users")
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                _vm.activeAnchorTxt(
                                                  "other-users"
                                                ) + " ml-3"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting
                                                      .profileTeamManagementOther
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayManageAgency
            ? _c(
                "v-expansion-panel-content",
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(_vm.lblSetting.profileAgencyManagementBtn)
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _vm.$route.meta["view_agency_char_pb"]
                            ? _c(
                                "v-list-tile",
                                { class: _vm.activeAnchor("char-problem") },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo("char-problem")
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "char-problem"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileCharacterProblem
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["view_agency_attachment_type"]
                            ? _c(
                                "v-list-tile",
                                { class: _vm.activeAnchor("attachment-type") },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "attachment-type"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "attachment-type"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileAttachmentType
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["manage_ticket_closure_reason"]
                            ? _c(
                                "v-list-tile",
                                {
                                  class: _vm.activeAnchor(
                                    "ticket-closing-reasons"
                                  )
                                },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "ticket-closing-reasons"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "ticket-closing-reasons"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileTicketClosingReason
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["manage_ticket_triggering_cause"]
                            ? _c(
                                "v-list-tile",
                                { class: _vm.activeAnchor("ticket-reasons") },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "ticket-reasons"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "ticket-reasons"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileTicketReasonsMenu
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["manage_ticket_substatus"]
                            ? _c(
                                "v-list-tile",
                                { class: _vm.activeAnchor("ticket-substatus") },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "ticket-substatus"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "ticket-substatus"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .ticketSubstatusMenu
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.meta["view_maintenance_template"]
                            ? _c(
                                "v-list-tile",
                                {
                                  class: _vm.activeAnchor(
                                    "maintenance-template"
                                  )
                                },
                                [
                                  _c("v-list-tile-content", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "sidebar-profile__item",
                                            attrs: {
                                              to: _vm.redirectTo(
                                                "maintenance-template"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.activeAnchorTxt(
                                                    "maintenance-template"
                                                  ) + " ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .profileTemplates
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a622d5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a622d5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/profile-sidebar/template.html
// module id = null
// module chunks = 